<div class="pageheader">
  <div class="page-title">
    <h1>MCP Servers</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'McpServer_Action_ShowLog'" [title]="'MCP servers log'">
        <app-change-log-link-entity type="McpServerEntity" [id]="''"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="xcontainer xcontainer-fixed">
  <div class="xrow">
    <div class="col-sm-12">
      <dx-data-grid biz-grid
        [selection]='{ mode: "none" }'
        [dataSource]='mcpServers'
        [bizHideSelectedRowsComponent]="true"
        [showResetButton]="true"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowRemoving)="onRowRemoving($event)"
        (onEditCanceled)="onEditCancelled($event)"
        (onEditingStart)="onEditingStart($event)"
        [bizEditRowOnDoubleClick]="true">
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-editing mode="popup"
          [allowAdding]="hasCreatePerm"
          [allowUpdating]="allowUpdatingRow"
          [allowDeleting]="allowDeletingRow">
        </dxo-editing>

        <dxi-column dataField="Name" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
        <dxi-column dataField="Description" caption="Description" dataType="string" [allowGrouping]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
        <dxi-column dataField="UrlKey" caption="Url key" dataType="string" editCellTemplate="urlKeyEditTemplate" [allowGrouping]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
        <dxi-column dataField="BuiltInSecurity" caption="Built-in security" dataType="boolean" [allowGrouping]="false"></dxi-column>
        <dxi-column dataField="AuthorizedUserGroupId" caption="Authorized user-group" [calculateSortValue]="getUserGroupSortValue" [calculateDisplayValue]="getUserGroupDisplayValue">
          <dxo-lookup [dataSource]="userGroupChoices" valueExpr="Id" displayExpr="Name"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="ArtifactId" caption="McpServer Artifact" dataType="string" editCellTemplate="artifactEditTemplate" [customizeText]="displayExprArtifact"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>

        <dxi-column type="buttons" [fixed]="true" fixedPosition="right">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Show Log"
            template="logTemplate"
            [visible]="allowShowLog">
          </dxi-button>
        </dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(mcpServers, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(mcpServers, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'McpServer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="McpServerEntity" [id]="cell.data.Id"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'urlKeyEditTemplate'">
          <dx-text-box [value]="cellInfo.value" (onValueChanged)="cellInfo.setValue($event.value)" valueChangeEvent="keyup"></dx-text-box>
          MCP endpoint will be: <i>{{baseApiUrl}}{{ trimLeadingSlashes(cellInfo.value) }}</i>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'artifactEditTemplate'">
          <app-developer-artifact-assembly-picker [assemblyTypes]="['McpServer']" (selectedArtifactIdChange)="setArtifactId($event, cellInfo)" [selectedArtifactId]="cellInfo.data.ArtifactId"></app-developer-artifact-assembly-picker>
          @if (mcpServerDisplayGroups.length > 0) {
            <ep-datafield-group-container [formValidationGroup]="mcpServerFormGroup" [showError]="true" [datafieldGroups]="mcpServerDisplayGroups" [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
          }
        </ng-container>
      </dx-data-grid>
    </div>
  </div>
</div>
